import { formatDateToString } from '@convenia/helpers'
import { SYSTEM_FIELD_TYPE_DATE } from '@convenia/common-organisms/SystemFields/content/consts/FieldTypes'

/**
 * Resolves custom field values for the edit form, keyed by the schema fields.
 *
 * Operates exclusively on custom fields — it does NOT touch API-origin system
 * field data. Date-type fields are normalized to `YYYY-MM-DD` (the format the
 * form-builder consumes); missing/invalid values become `null`.
 *
 * @param {Object} schema - Custom field definitions keyed by field ID (type-aware)
 * @param {Object} values - Raw custom field values keyed by field ID
 * @returns {Object} Custom field values ready for the edit form
 */
export const resolveCustomFieldValues = (schema, values) =>
  Object.keys(schema || {}).reduce((acc, key) => {
    const value = values?.[key]

    acc[key] = schema[key]?.type === SYSTEM_FIELD_TYPE_DATE
      ? formatDateToString(value)
      : value ?? null

    return acc
  }, {})
